<template>
    <div class="ai-service-shell">
        <transition name="ai-teaser-fade">
            <div v-if="proactiveVisible && !dialogVisible" class="ai-product-teaser" role="dialog"
                aria-label="AI 智能客服产品咨询">
                <button type="button" class="ai-teaser-main" @click="openChat">
                    <img src="@/assets/img/kefu2.png" alt="">
                    <span>
                        <strong>正在看这款产品吗？</strong>
                        <small>可以问我价格、配置、运输和售后</small>
                    </span>
                </button>
                <button type="button" class="ai-teaser-close" aria-label="关闭提示" @click="dismissProactive">×</button>
            </div>
        </transition>

        <el-dialog :visible.sync="dialogVisible" :width="dialogWidth" append-to-body
            custom-class="ai-chat-dialog" :close-on-click-modal="false" @open="handleOpen">
            <div slot="title" class="ai-chat-title">
                <img src="@/assets/img/kefu2.png" alt="">
                <div>
                    <strong>AI 智能客服</strong>
                    <span>{{ productContext ? `正在为您介绍：${productContext}` : '产品、报价、经销合作与售后咨询' }}</span>
                </div>
                <button type="button" class="ai-contact-button" @click="openLeadForm">留下联系方式</button>
            </div>

            <div class="ai-chat-layout">
                <section class="ai-chat-panel" aria-label="客服对话窗口">
                    <div ref="messageList" class="ai-message-list" aria-live="polite">
                        <div v-for="message in messages" :key="message.id"
                            :class="['ai-message', `is-${message.role}`]">
                            <img v-if="message.role === 'assistant'" src="@/assets/img/kefu2.png" alt="">
                            <div class="ai-message-bubble">
                                <span>{{ message.text }}</span>
                                <button v-if="message.suggestContact" type="button" class="ai-message-contact"
                                    @click="openLeadForm">留下联系方式，获取人工跟进</button>
                            </div>
                        </div>
                        <div v-if="sending" class="ai-message is-assistant">
                            <img src="@/assets/img/kefu2.png" alt="">
                            <div class="ai-message-bubble ai-typing"><i></i><i></i><i></i></div>
                        </div>
                    </div>

                    <div class="ai-quick-prompts" aria-label="常用问题">
                        <button v-for="prompt in quickPrompts" :key="prompt" type="button"
                            :disabled="sending" @click="sendPrompt(prompt)">{{ prompt }}</button>
                    </div>

                    <div class="ai-composer">
                        <el-input v-model="chatInput" type="textarea" :rows="2" maxlength="500"
                            placeholder="请输入您想了解的问题，例如：这款车多少钱？续航多少？"
                            @keydown.native="handleComposerKeydown"></el-input>
                        <el-button type="primary" :loading="sending" :disabled="!chatInput" @click="sendMessage">发送</el-button>
                    </div>
                    <p class="ai-chat-note">涉及最终价格、配置、交期和认证时，以销售人员确认结果为准。</p>
                </section>

                <aside v-if="leadMode" class="ai-lead-panel" aria-label="留下联系方式">
                    <div class="ai-lead-heading">
                        <div><strong>获取人工跟进</strong><span>提交后，业务人员会尽快联系您。</span></div>
                        <button type="button" aria-label="关闭联系方式表单" @click="leadMode = false">×</button>
                    </div>
                    <el-form ref="leadForm" :model="form" :rules="rules" label-position="top">
                        <el-form-item label="公司名称" prop="company">
                            <el-input v-model="form.company" maxlength="40" placeholder="请输入公司名称"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人">
                            <el-input v-model="form.contact" maxlength="20" placeholder="请输入联系人姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话">
                            <el-input v-model="form.phone" maxlength="22" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                        <el-form-item label="微信">
                            <el-input v-model="form.wechat" maxlength="30" placeholder="请输入微信号"></el-input>
                        </el-form-item>
                        <el-form-item label="咨询需求">
                            <el-input v-model="form.message" type="textarea" :rows="2" maxlength="100"
                                placeholder="车型、数量、用途或合作方式"></el-input>
                        </el-form-item>
                        <el-button class="ai-lead-submit" type="primary" :loading="submitting"
                            @click="submitLead">提交联系方式</el-button>
                        <p class="ai-privacy">资料仅用于富贵泉业务联系与客户服务。</p>
                    </el-form>
                </aside>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getTrackingContext } from '@/utils/customerTracking'

export default {
    name: 'AiChatService',
    props: {
        visible: { type: Boolean, default: false }
    },
    data() {
        return {
            proactiveVisible: false,
            proactiveTimer: null,
            productContext: '',
            conversationRoute: '',
            conversationId: '',
            chatInput: '',
            sending: false,
            messages: [],
            messageId: 0,
            leadMode: false,
            submitting: false,
            form: { company: '', contact: '', phone: '', wechat: '', message: '' },
            rules: {
                company: [{ required: true, message: '请填写公司名称', trigger: 'blur' }]
            }
        }
    },
    computed: {
        dialogVisible: {
            get() { return this.visible },
            set(value) { this.$emit('update:visible', value) }
        },
        dialogWidth() {
            if (this.$store.state.winWidth <= 768) return '94%'
            return this.leadMode ? '920px' : '720px'
        },
        quickPrompts() {
            return this.productContext
                ? ['获取这款车报价', '了解主要配置', '运输与交期', '经销合作']
                : ['推荐适合的车型', '获取产品报价', '经销合作', '售后与配件']
        }
    },
    watch: {
        '$route.fullPath'() {
            this.proactiveVisible = false
            this.refreshProductContext()
            this.scheduleProactive()
        }
    },
    mounted() {
        this.refreshProductContext()
        this.scheduleProactive()
    },
    beforeDestroy() {
        window.clearTimeout(this.proactiveTimer)
    },
    methods: {
        refreshProductContext() {
            this.$nextTick(() => {
                window.setTimeout(() => {
                    const candidates = Array.from(document.querySelectorAll('h1, [data-product-name]'))
                    const heading = candidates.find(node => node && node.textContent && node.textContent.trim())
                    const title = (heading && heading.textContent.trim()) || document.title.split('|')[0].trim()
                    this.productContext = this.$route.name === 'show'
                        ? (title || `产品 ${this.$route.query.id || ''}`.trim())
                        : ''
                }, 400)
            })
        },
        scheduleProactive() {
            window.clearTimeout(this.proactiveTimer)
            if (this.$route.name !== 'show') return
            const key = `fgq-ai-teaser:${this.$route.fullPath}`
            if (window.sessionStorage.getItem(key)) return
            this.proactiveTimer = window.setTimeout(() => {
                this.refreshProductContext()
                this.proactiveVisible = true
            }, 1800)
        },
        dismissProactive() {
            this.proactiveVisible = false
            window.sessionStorage.setItem(`fgq-ai-teaser:${this.$route.fullPath}`, '1')
        },
        openChat() {
            this.dismissProactive()
            this.dialogVisible = true
        },
        handleOpen() {
            this.refreshProductContext()
            if (this.conversationRoute !== this.$route.fullPath || !this.messages.length) {
                this.conversationRoute = this.$route.fullPath
                this.conversationId = ''
                this.messages = []
                const greeting = this.$route.name === 'show'
                    ? '您好，我是富贵泉 AI 智能客服。请告诉我这款车的使用场景、使用地区和预计数量，我可以先帮您核对合适配置；需要准确报价时，再为您安排业务人员跟进。'
                    : '您好，我是富贵泉 AI 智能客服。您想找载货、载人还是环卫用途的电动三轮车？告诉我使用场景、使用地区和预计数量，我可以先帮您缩小车型范围。'
                this.addMessage('assistant', greeting)
            }
            this.scrollToBottom()
        },
        addMessage(role, text, suggestContact = false) {
            this.messages.push({ id: ++this.messageId, role, text, suggestContact })
            this.scrollToBottom()
        },
        sendPrompt(prompt) {
            this.chatInput = prompt
            this.sendMessage()
        },
        handleComposerKeydown(event) {
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault()
                this.sendMessage()
            }
        },
        sendMessage() {
            const text = this.chatInput.trim()
            if (!text || this.sending) return
            this.chatInput = ''
            this.addMessage('user', text)
            this.sending = true

            const history = this.messages
                .filter(item => item.role === 'user' || item.role === 'assistant')
                .slice(-8)
                .map(item => ({ role: item.role, content: item.text }))

            this.$api.aiChat({
                ...getTrackingContext('zh'),
                language: 'zh',
                message: text,
                product: this.productContext,
                page_context: this.collectPageContext(),
                conversation_id: this.conversationId,
                messages: history
            }).then(res => {
                const reply = res && res.data && res.data.reply
                if (!reply) throw new Error('empty reply')
                if (res.data.conversation_id) this.conversationId = res.data.conversation_id
                this.addMessage('assistant', reply, Boolean(res.data.suggest_contact))
            }).catch(() => {
                const fallback = this.localReply(text)
                this.addMessage('assistant', fallback.text, fallback.suggestContact)
            }).finally(() => {
                this.sending = false
                this.scrollToBottom()
            })
        },
        collectPageContext() {
            const main = document.querySelector('main') || document.querySelector('#app')
            if (!main) return ''
            return main.innerText.replace(/\s+/g, ' ').trim().slice(0, 1600)
        },
        localReply(text) {
            const product = this.productContext || '这款电动三轮车'
            const conversation = this.messages.map(item => item.text).join(' ')
            const userTurns = this.messages.filter(item => item.role === 'user').length
            const buyingIntent = /价格|报价|多少钱|批发|采购|订购|购买|数量|经销|代理|加盟|合作|OEM|ODM|CKD|SKD|运输|物流|发货|交期/i.test(conversation)
            const result = (reply, suggestContact = false) => ({ text: reply, suggestContact })
            if (/^(你好|您好|嗨|在吗|你好呀)[！!。.？?\s]*$/.test(text)) {
                return result('您好，我在。您想找载货、载人还是环卫用途的电动三轮车？')
            }
            if (/推荐|哪款|什么车型|适合|怎么选|选择车型/.test(text)) {
                return result(`我可以帮您筛选适合的车型。${product}主要用于载货、载人还是环卫作业？预计载重和路况怎样？`)
            }
            if (/价格|报价|多少钱|批发价/.test(text)) {
                return result(`我可以协助申请${product}的报价。价格会随配置和采购数量变化，请问需要多少辆、使用或收货地区在哪里？`, true)
            }
            if (/参数|续航|电池|电机|载重|尺寸|配置/.test(text)) {
                return result(`不同车型和配置会有差异。您最关注${product}的电池、电机、续航、载重还是尺寸？页面未公开的数据我不会猜测，需要由业务人员确认。`, userTurns >= 2)
            }
            if (/经销|代理|加盟|合作|OEM|ODM|CKD|SKD/i.test(text)) {
                return result('富贵泉支持经销合作及 OEM/ODM、CKD/SKD 业务咨询。请问您的公司主要服务哪个市场，首批预计需要多少辆？业务人员可据此跟进合作方案。', true)
            }
            if (/运输|物流|发货|交期|售后|保修|配件/.test(text)) {
                return result('运输、交期、保修和配件方案需结合车型、数量及收货地区确认。请问送到哪个城市或地区？留下联系方式后，业务人员可以提供确认方案。', true)
            }
            if (buyingIntent && /\d+|地区|城市|省|市场|港口/.test(text)) {
                return result('谢谢，这些信息有助于确认需求。您可以在联系方式表单里留下电话或微信，业务人员会根据车型、数量和地区跟进准确报价与交付方案。', true)
            }
            return result(`我可以继续帮您了解${product}的车型、参数、报价、合作、运输及售后。请先告诉我主要用途和使用地区。`, buyingIntent && userTurns >= 2)
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const list = this.$refs.messageList
                if (list) list.scrollTop = list.scrollHeight
            })
        },
        resetLeadForm() {
            this.form = { company: '', contact: '', phone: '', wechat: '', message: '' }
            this.$nextTick(() => this.$refs.leadForm && this.$refs.leadForm.clearValidate())
        },
        openLeadForm() {
            if (!this.form.message) {
                this.form.message = this.messages
                    .filter(item => item.role === 'user')
                    .slice(-3)
                    .map(item => item.text.trim())
                    .filter(Boolean)
                    .join('；')
                    .slice(0, 100)
            }
            this.leadMode = true
        },
        normalizeLeadForm() {
            Object.keys(this.form).forEach(key => {
                this.form[key] = String(this.form[key] || '').replace(/\s+/g, ' ').trim()
            })
        },
        submitLead() {
            this.normalizeLeadForm()
            this.$refs.leadForm.validate(valid => {
                if (!valid) return
                if (!this.form.phone && !this.form.wechat) {
                    this.$message.warning('请至少填写电话或微信其中一项')
                    return
                }
                this.submitting = true
                this.$api.addCustomerLead({
                    ...getTrackingContext('zh'),
                    conversation_id: this.conversationId,
                    source: 'ai_chat',
                    company: this.form.company,
                    contact_name: this.form.contact,
                    email: '',
                    phone: this.form.phone,
                    im_type: this.form.wechat ? 'wechat' : '',
                    im_account: this.form.wechat,
                    product: this.productContext,
                    inquiry: this.form.message
                }).then(res => {
                    if (!res || res.code !== 1) throw new Error('submit failed')
                    this.$message.success('提交成功，我们会尽快与您联系')
                    this.addMessage('assistant', '联系方式已收到，业务人员会尽快与您联系。您也可以继续在这里提问。')
                    this.leadMode = false
                    this.resetLeadForm()
                }).catch(() => {
                    this.$message.error('暂时无法提交，请稍后重试或直接电话联系我们')
                }).finally(() => { this.submitting = false })
            })
        }
    }
}
</script>

<style lang="scss">
.ai-chat-dialog {
    border-radius: 16px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 22px 70px rgba(0, 0, 0, 0.28);

    .el-dialog__header { padding: 20px 24px 14px; border-bottom: 1px solid #eceff1; }
    .el-dialog__body { padding: 0; }
    .el-dialog__headerbtn { top: 18px; right: 18px; }
    .el-form-item { margin-bottom: 12px; }
    .el-form-item__label { padding-bottom: 2px; font-weight: 600; line-height: 20px; }
    .el-button--primary { background: #b00d16; border-color: #b00d16; }
}

.ai-chat-title {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-right: 30px;

    > img { width: 42px; height: 42px; object-fit: contain; }
    > div { min-width: 0; display: flex; flex: 1; flex-direction: column; gap: 3px; }
    strong { color: #171717; font-size: 20px; }
    span { overflow: hidden; color: #6c747a; font-size: 13px; text-overflow: ellipsis; white-space: nowrap; }
}

.ai-contact-button {
    flex-shrink: 0;
    padding: 8px 12px;
    border: 1px solid #b00d16;
    border-radius: 999px;
    background: #fff;
    color: #b00d16;
    font-size: 13px;
    cursor: pointer;
}

.ai-chat-layout { position: relative; display: flex; height: min(620px, 76vh); background: #f7f8f9; }
.ai-chat-panel { min-width: 0; display: flex; flex: 1; flex-direction: column; }
.ai-message-list { flex: 1; padding: 22px 24px 12px; overflow-y: auto; scroll-behavior: smooth; }
.ai-message { display: flex; align-items: flex-start; gap: 9px; margin-bottom: 14px; }
.ai-message > img { width: 30px; height: 30px; object-fit: contain; }
.ai-message-bubble { max-width: 76%; display: flex; flex-direction: column; align-items: flex-start; padding: 11px 14px; border-radius: 4px 14px 14px; background: #fff; color: #25282b; font-size: 14px; line-height: 1.65; box-shadow: 0 2px 10px rgba(0,0,0,.06); }
.ai-message-bubble > span { white-space: pre-wrap; }
.ai-message-contact { align-self: flex-start; margin-top: 9px; padding: 6px 10px; border: 1px solid #b00d16; border-radius: 999px; background: #fff; color: #b00d16; font: inherit; font-size: 12px; line-height: 1.2; cursor: pointer; }
.ai-message.is-user { justify-content: flex-end; }
.ai-message.is-user .ai-message-bubble { border-radius: 14px 4px 14px 14px; background: #b00d16; color: #fff; box-shadow: none; }
.ai-typing { display: flex; gap: 4px; align-items: center; min-height: 38px; }
.ai-typing i { width: 6px; height: 6px; border-radius: 50%; background: #a3a7aa; animation: ai-dot 1.1s infinite ease-in-out; }
.ai-typing i:nth-child(2) { animation-delay: .15s; }
.ai-typing i:nth-child(3) { animation-delay: .3s; }
@keyframes ai-dot { 0%, 60%, 100% { transform: translateY(0); } 30% { transform: translateY(-5px); } }

.ai-quick-prompts { display: flex; gap: 8px; padding: 8px 20px; overflow-x: auto; }
.ai-quick-prompts button { flex-shrink: 0; padding: 7px 11px; border: 1px solid #d9dde1; border-radius: 999px; background: #fff; color: #4f575e; font-size: 12px; cursor: pointer; }
.ai-quick-prompts button:hover { border-color: #b00d16; color: #b00d16; }
.ai-composer { display: flex; align-items: flex-end; gap: 10px; padding: 10px 20px 8px; border-top: 1px solid #e1e4e7; background: #fff; }
.ai-composer .el-textarea { flex: 1; }
.ai-composer .el-textarea__inner { resize: none; }
.ai-composer .el-button { height: 42px; }
.ai-chat-note { margin: 0; padding: 0 20px 12px; background: #fff; color: #92989d; font-size: 11px; }

.ai-lead-panel { width: 310px; flex-shrink: 0; padding: 20px; overflow-y: auto; border-left: 1px solid #e1e4e7; background: #fff; }
.ai-lead-heading { display: flex; justify-content: space-between; gap: 10px; margin-bottom: 14px; }
.ai-lead-heading > div { display: flex; flex-direction: column; gap: 4px; }
.ai-lead-heading strong { color: #202326; font-size: 17px; }
.ai-lead-heading span { color: #737b81; font-size: 12px; line-height: 1.5; }
.ai-lead-heading button { align-self: flex-start; border: 0; background: transparent; color: #8b9297; font-size: 22px; cursor: pointer; }
.ai-lead-submit { width: 100%; }
.ai-privacy { margin: 10px 0 0; color: #8b9297; font-size: 11px; line-height: 1.5; }

.ai-product-teaser {
    position: fixed;
    right: 90px;
    top: calc(50% - 25px);
    z-index: 97;
    width: 330px;
    overflow: hidden;
    border: 1px solid rgba(176, 13, 22, .16);
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 14px 38px rgba(0, 0, 0, .2);
}
.ai-teaser-main { width: 100%; display: flex; align-items: center; gap: 11px; padding: 14px 34px 14px 14px; border: 0; background: transparent; text-align: left; cursor: pointer; }
.ai-teaser-main img { width: 36px; height: 36px; object-fit: contain; }
.ai-teaser-main span { min-width: 0; display: flex; flex-direction: column; gap: 3px; }
.ai-teaser-main strong { color: #202326; font-size: 14px; }
.ai-teaser-main small { color: #687078; font-size: 12px; line-height: 1.45; }
.ai-teaser-close { position: absolute; top: 6px; right: 8px; border: 0; background: transparent; color: #9aa0a5; font-size: 18px; cursor: pointer; }
.ai-teaser-fade-enter-active, .ai-teaser-fade-leave-active { transition: opacity .25s ease, transform .25s ease; }
.ai-teaser-fade-enter, .ai-teaser-fade-leave-to { opacity: 0; transform: translateX(18px); }

@media (max-width: 768px) {
    .ai-chat-dialog {
        max-height: 88vh;
        margin-top: 5vh !important;
        display: flex;
        flex-direction: column;
        .el-dialog__header { flex: 0 0 auto; padding: 14px 14px 10px; }
        .el-dialog__body { min-height: 0; flex: 1 1 auto; }
        .el-dialog__headerbtn { top: 12px; right: 10px; font-size: 18px; }
        .el-form-item { margin-bottom: 10px; }
        .el-form-item__label { padding-bottom: 2px; font-size: 13px; line-height: 18px; }
        .el-input__inner { height: 38px; padding: 0 10px; font-size: 14px; line-height: 38px; }
        .el-textarea__inner { padding: 9px 10px; font-size: 14px; line-height: 1.5; }
        .el-button { padding: 9px 12px; font-size: 14px; }
    }
    .ai-chat-title { gap: 8px; padding-right: 22px; }
    .ai-chat-title > img { width: 34px; height: 34px; }
    .ai-chat-title strong { font-size: 17px; }
    .ai-chat-title span { max-width: 155px; font-size: 11px; }
    .ai-contact-button { padding: 6px 8px; font-size: 11px; }
    .ai-chat-layout { height: 76vh; }
    .ai-message-list { padding: 14px 12px 8px; }
    .ai-message { gap: 6px; margin-bottom: 10px; }
    .ai-message > img { width: 27px; height: 27px; }
    .ai-message-bubble { max-width: 83%; padding: 9px 11px; font-size: 14px; line-height: 1.55; }
    .ai-quick-prompts { gap: 6px; padding: 6px 10px; }
    .ai-quick-prompts button { padding: 6px 9px; font-size: 12px; }
    .ai-composer { gap: 7px; padding: 8px 10px 6px; }
    .ai-composer .el-button { height: 40px; }
    .ai-chat-note { padding: 0 10px 8px; font-size: 10px; line-height: 1.4; }
    .ai-lead-panel { position: absolute; inset: 8px; z-index: 3; width: auto; padding: 16px; border: 1px solid #e1e4e7; border-radius: 12px; box-shadow: 0 12px 36px rgba(0,0,0,.2); }
    .ai-lead-heading strong { font-size: 17px; }
    .ai-lead-heading span { font-size: 12px; }
    .ai-privacy { font-size: 11px; }
    .ai-product-teaser { right: 12px; top: auto; bottom: 18px; width: calc(100vw - 24px); border-radius: 12px; }
    .ai-teaser-main { gap: 9px; padding: 11px 32px 11px 12px; }
    .ai-teaser-main img { width: 32px; height: 32px; }
    .ai-teaser-main strong { font-size: 14px; }
    .ai-teaser-main small { font-size: 12px; }
}
</style>
